"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("antd/es/button/style/css");

var _button = _interopRequireDefault(require("antd/es/button"));

var _react = _interopRequireDefault(require("react"));

var _icons = require("@ant-design/icons");

var _form = _interopRequireDefault(require("antd/lib/form"));

var _QuestionItem = _interopRequireDefault(require("./QuestionItem"));

require("../activity.scss");

const {
  Item
} = _form.default;

const DynamicQuestionItems = props => {
  const {
    questions,
    typeId,
    disabled,
    updateQuestion,
    addQuestion,
    removeQuestion,
    options
  } = props;

  const onAddClick = e => {
    e.preventDefault();
    addQuestion();
  };

  const items = questions.map((q, index) => {
    return /*#__PURE__*/_react.default.createElement("li", {
      key: `question-item-${q.id ? q.id : q.uuid}`,
      className: "question-list-container"
    }, /*#__PURE__*/_react.default.createElement(_QuestionItem.default, {
      typeId: typeId,
      disabled: disabled,
      question: q,
      options: options,
      updateQuestion: q => updateQuestion(q, index)
    }), questions.length > 1 && !disabled && /*#__PURE__*/_react.default.createElement("button", {
      className: "dashed-danger-button",
      onClick: () => removeQuestion(index)
    }, /*#__PURE__*/_react.default.createElement(_icons.MinusOutlined, null), ' ', "Remove Question"));
  });
  return /*#__PURE__*/_react.default.createElement("ul", {
    className: "dynamic-question-items"
  }, items, !disabled && /*#__PURE__*/_react.default.createElement(Item, null, /*#__PURE__*/_react.default.createElement(_button.default, {
    type: "dashed",
    onClick: onAddClick,
    style: {
      width: '100%'
    }
  }, /*#__PURE__*/_react.default.createElement(_icons.PlusOutlined, null), ' ', "Add question")));
};

var _default = DynamicQuestionItems;
exports.default = _default;